import Avatar from '@material-ui/core/Avatar';
import { getSvgPath } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import styled from 'styled-components';
import ToolTip from 'globalcomponents/ToolTip';
import { Link as RouterLink } from 'react-router-dom';

const layout = window?.$environment?.CURRENT_LAYOUT;
const SvgIcon = lazy(() => import(`../../../SvgIcon/${layout}`));
const Link = lazy(() => import(`../../Link`));

const StyledAvatar = styled(Avatar)`
  background: transparent !important;
  color: ${({ theme, primary }) =>
    `${primary ? theme.colors?.PRIMARY_CONTRAST : theme.palette?.secondary?.main || theme.colors?.SECONDARY_MAIN || '#888'
    } !important`};
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const StyledRouterLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const Icon = ({
  onClick,
  link,
  to,
  src = '',
  variant,
  addFilter,
  tableicon,
  className,
  tooltip = '',
  IconContainer,
  id,
  asLink,
  style,
  text,
  alignItems,
  primary = false,
}) => {
  const isSvg = typeof src === 'string' && (src?.includes('.svg') || src?.includes('data:image'));

  const handleClick = (e) => {
    // If modifier keys are pressed (Ctrl, Cmd, Shift, etc.), let browser handle it (open in new tab)
    if (to && (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1)) {
      return;
    }
    onClick(e);
  };

  // Disable focus listener so tooltip only shows on hover and doesn't persist after
  // click (MUI Tooltip shows on focus by default; click gives focus so tooltip sticks).
  const tooltipProps = tooltip ? { disableFocusListener: true } : {};

  const getComponent = () => {
    if (link) {
      return (
        <ToolTip title={tooltip} {...tooltipProps}>
          <a href={link}>
            <Avatar alt="icon" src={getSvgPath(src)} variant={variant} />
          </a>
        </ToolTip>
      );
    }
    if (asLink) {
      return (
        <ToolTip title={tooltip} {...tooltipProps}>
          <Link onClick={handleClick}>{text}</Link>
        </ToolTip>
      );
    }

    // Handle React Router link with Ctrl+Click support
    if (to) {
      if (isSvg) {
        return (
          <ToolTip title={tooltip}>
            <StyledRouterLink to={to} onClick={handleClick}>
              <StyledAvatar
                variant={variant || 'round'}
                alt="icon"
                primary={primary}
              >
                <SvgIcon value={src} className={className} />
              </StyledAvatar>
            </StyledRouterLink>
          </ToolTip>
        );
      }
      return (
        <ToolTip title={tooltip}>
          <StyledRouterLink to={to} onClick={handleClick}>
            <Avatar
              alt="icon"
              className={addFilter ? 'addFilter' : ''}
              src={getSvgPath(src) || src || undefined}
              variant={variant}
            />
          </StyledRouterLink>
        </ToolTip>
      );
    }

    if (isSvg) {
      return (
        <ToolTip title={tooltip} {...tooltipProps}>
          <StyledAvatar
            variant={variant || 'round'}
            alt="icon"
            primary={primary}
            onClick={handleClick}
          >
            <SvgIcon value={src} className={className} />
          </StyledAvatar>
        </ToolTip>
      );
    }

    return (
      <ToolTip title={tooltip} {...tooltipProps}>
        <Avatar
          alt="icon"
          className={addFilter ? 'addFilter' : ''}
          src={getSvgPath(src) || src || undefined}
          onClick={handleClick}
          variant={variant}
        />
      </ToolTip>
    );
  };
  return (
    <IconContainer
      container
      justify="flex-start"
      alignItems={alignItems || 'center'}
      isSvg={isSvg}
      tableicon={tableicon}
      style={style}
      className={className ? className : 'iconContainer'}
      id={id || ''}
    >
      {getComponent()}
    </IconContainer>
  );
};

Icon.defaultProps = {
  link: '',
  to: '',
  src: '',
  onClick: () => { },
  variant: 'rounded',
};

Icon.propTypes = {
  link: PropTypes.string,
  to: PropTypes.string,
  src: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
};

export default Icon;
